import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, subtitle, lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-black text-white">
      <header className="border-b border-zinc-900 px-6 md:px-12 py-6">
        <div className="max-w-[1100px] mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 text-zinc-400 hover:text-white transition">
            <ArrowLeft size={14} />
            <span className="font-mono text-[10px] tracking-[0.3em] uppercase">Back</span>
          </Link>
          <Link to="/">
            <Logo size="sm" />
          </Link>
          <div className="w-16" />
        </div>
      </header>

      <main className="max-w-[820px] mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-zinc-500 mb-4">
          {subtitle}
        </div>
        <h1 className="font-display font-light uppercase tracking-tight text-4xl md:text-6xl leading-[1]">
          {title}
        </h1>
        <div className="mt-6 font-mono text-[10px] tracking-[0.3em] uppercase text-zinc-600">
          Last Updated · {lastUpdated}
        </div>
        <div className="mt-12 hairline" />
        <article className="legal-prose mt-12 text-zinc-300 font-sans leading-relaxed space-y-6">
          {children}
        </article>
      </main>

      <footer className="border-t border-zinc-900 px-6 md:px-12 py-10 mt-24">
        <div className="max-w-[1100px] mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <span className="font-mono text-[10px] tracking-[0.4em] uppercase text-zinc-500">
            © CAMO · All Rights Reserved
          </span>
          <div className="flex gap-6">
            {[
              ["Terms", "/legal/terms"],
              ["Privacy", "/legal/privacy"],
              ["Refund", "/legal/refund"],
              ["Cookies", "/legal/cookies"],
            ].map(([l, h]) => (
              <Link key={h} to={h} className="font-mono text-[10px] tracking-[0.3em] uppercase text-zinc-500 hover:text-white transition">
                {l}
              </Link>
            ))}
          </div>
        </div>
      </footer>
    </div>
  );
}

export const H2 = ({ children }) => (
  <h2 className="font-display text-2xl md:text-3xl uppercase tracking-tight mt-12 mb-4 text-white">{children}</h2>
);
export const P = ({ children }) => (
  <p className="text-zinc-300 leading-relaxed text-base">{children}</p>
);
export const UL = ({ children }) => (
  <ul className="list-disc pl-6 space-y-2 text-zinc-300 marker:text-zinc-600">{children}</ul>
);
